export default __webpack_public_path__ + "a657bcd50c7e72ec7dbcc2e610aec133.png";